import { useState, useEffect } from "react";
import axios from "axios";

// const BASE_URL = "https://staging.pteshstudios.com";
const BASE_URL = "https://api.jeyshawnng.com";

const getToken     = () => localStorage.getItem("adminToken");
const authHeaders  = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

const styles = `
  .at__wrapper { width: 100%; background: #fff; padding-top: 80px; }
  .at__toolbar { display: flex; align-items: center; justify-content: space-between; padding: 16px 24px; border-bottom: 1px solid #f0f0f0; gap: 12px; flex-wrap: wrap; }
  .at__toolbar-left { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .at__search { display: flex; align-items: center; gap: 8px; background: #f7f7f7; border: 1px solid #e8e8e8; border-radius: 6px; padding: 7px 12px; min-width: 220px; }
  .at__search-icon { color: #aaa; font-size: 13px; flex-shrink: 0; }
  .at__search input { border: none; background: transparent; outline: none; font-size: 13px; color: #333; width: 100%; }
  .at__search input::placeholder { color: #bbb; }
  .at__toolbar-right { display: flex; align-items: center; gap: 10px; }
  .at__count { font-size: 13px; color: #888; white-space: nowrap; }
  .at__add-btn { display: flex; align-items: center; gap: 6px; background: #1b5e20; color: #fff; border: none; border-radius: 6px; padding: 7px 16px; font-size: 13px; font-weight: 600; cursor: pointer; transition: background 0.15s; white-space: nowrap; }
  .at__add-btn:hover { background: #2e7d32; }
  .at__table-wrap { width: 100%; overflow-x: auto; }
  .at__table { width: 100%; border-collapse: collapse; min-width: 700px; }
  .at__table thead tr { background: #fafafa; border-bottom: 2px solid #f0f0f0; }
  .at__table thead th { padding: 13px 16px; text-align: left; font-size: 12px; font-weight: 700; color: #333; letter-spacing: 0.4px; text-transform: uppercase; white-space: nowrap; user-select: none; cursor: pointer; }
  .at__table thead th:hover { color: #1b5e20; }
  .at__table tbody tr { border-bottom: 1px solid #f5f5f5; transition: background 0.1s; }
  .at__table tbody tr:hover { background: #f9fdf9; }
  .at__table tbody td { padding: 14px 16px; font-size: 13.5px; color: #444; white-space: nowrap; }
  .at__status-badge { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 500; }
  .at__status-badge--active { background: #e8f5e9; color: #1b5e20; }
  .at__status-badge--inactive { background: #fce4ec; color: #c62828; }
  .at__actions { display: flex; align-items: center; gap: 8px; }
  .at__action-btn { border: none; border-radius: 5px; padding: 5px 10px; font-size: 12px; font-weight: 500; cursor: pointer; transition: all 0.15s; }
  .at__action-btn--edit { background: #e3f2fd; color: #1565c0; }
  .at__action-btn--edit:hover { background: #bbdefb; }
  .at__action-btn--delete { background: #fce4ec; color: #c62828; }
  .at__action-btn--delete:hover { background: #f8bbd0; }
  .at__action-btn--enable { background: #e8f5e9; color: #1b5e20; }
  .at__action-btn--enable:hover { background: #c8e6c9; }
  .at__action-btn--disable { background: #fff3e0; color: #e65100; }
  .at__action-btn--disable:hover { background: #ffe0b2; }
  .at__empty { text-align: center; padding: 60px 20px; color: #bbb; font-size: 14px; }
  .at__loading { text-align: center; padding: 60px 20px; color: #888; font-size: 14px; }
  .at__fetch-error { margin: 16px 24px; background: #fff0f0; border: 1px solid #ffc9c9; border-radius: 8px; padding: 10px 14px; font-size: 13px; color: #c62828; }
  .at__pagination { display: flex; align-items: center; justify-content: space-between; padding: 14px 24px; border-top: 1px solid #f0f0f0; flex-wrap: wrap; gap: 10px; }
  .at__pagination-info { font-size: 13px; color: #888; }
  .at__pagination-btns { display: flex; align-items: center; gap: 4px; }
  .at__page-btn { width: 32px; height: 32px; border: 1px solid #e0e0e0; background: #fff; border-radius: 6px; font-size: 13px; color: #555; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.15s; }
  .at__page-btn:hover:not(:disabled) { background: #f5f5f5; border-color: #ccc; }
  .at__page-btn--active { background: #1b5e20 !important; color: #fff !important; border-color: #1b5e20 !important; }
  .at__page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .at__toast { position: fixed; bottom: 24px; right: 24px; z-index: 9999; background: #1b5e20; color: #fff; padding: 12px 20px; border-radius: 8px; font-size: 13px; font-weight: 500; box-shadow: 0 4px 16px rgba(0,0,0,0.15); animation: atToastIn 0.3s ease; }
  .at__toast--error { background: #c62828; }
  @keyframes atToastIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
  .at__modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .at__modal { background: #fff; border-radius: 14px; width: 100%; max-width: 480px; max-height: 90vh; overflow-y: auto; box-shadow: 0 8px 40px rgba(0,0,0,0.18); animation: atModalIn 0.25s ease; }
  @keyframes atModalIn { from { opacity: 0; transform: translateY(20px) scale(0.97); } to { opacity: 1; transform: translateY(0) scale(1); } }
  .at__modal-header { display: flex; align-items: center; justify-content: space-between; padding: 20px 24px 16px; border-bottom: 1px solid #f0f0f0; }
  .at__modal-title { font-size: 17px; font-weight: 700; color: #1a1a1a; }
  .at__modal-close { background: none; border: none; font-size: 20px; color: #aaa; cursor: pointer; line-height: 1; padding: 0; transition: color 0.15s; }
  .at__modal-close:hover { color: #333; }
  .at__modal-body { padding: 20px 24px; display: flex; flex-direction: column; gap: 16px; }
  .at__modal-field { display: flex; flex-direction: column; gap: 6px; }
  .at__modal-label { font-size: 12px; font-weight: 600; color: #444; letter-spacing: 0.3px; text-transform: uppercase; }
  .at__modal-input, .at__modal-select { width: 100%; border: 1.5px solid #e4e8e4; border-radius: 8px; padding: 10px 14px; font-size: 14px; color: #222; outline: none; transition: border-color 0.2s, box-shadow 0.2s; background: #fafafa; font-family: inherit; box-sizing: border-box; }
  .at__modal-input:focus, .at__modal-select:focus { border-color: #1b5e20; box-shadow: 0 0 0 3px rgba(27,94,32,0.08); background: #fff; }
  .at__modal-input::placeholder { color: #ccc; }
  .at__modal-pw-wrap { position: relative; display: flex; align-items: center; }
  .at__modal-pw-wrap .at__modal-input { padding-right: 40px; }
  .at__modal-eye { position: absolute; right: 12px; background: none; border: none; cursor: pointer; color: #aaa; font-size: 15px; padding: 0; display: flex; align-items: center; }
  .at__modal-eye:hover { color: #555; }
  .at__modal-two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .at__modal-error { background: #fff0f0; border: 1px solid #ffc9c9; border-radius: 8px; padding: 9px 13px; font-size: 13px; color: #c62828; display: flex; align-items: center; gap: 6px; }
  .at__modal-footer { display: flex; align-items: center; justify-content: flex-end; gap: 10px; padding: 16px 24px 20px; border-top: 1px solid #f0f0f0; }
  .at__modal-btn-cancel { background: #fff; border: 1px solid #e0e0e0; border-radius: 7px; padding: 9px 20px; font-size: 13px; color: #555; cursor: pointer; font-family: inherit; }
  .at__modal-btn-cancel:hover { background: #f5f5f5; }
  .at__modal-btn-save { background: #1b5e20; color: #fff; border: none; border-radius: 7px; padding: 9px 22px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; display: flex; align-items: center; gap: 6px; }
  .at__modal-btn-save:hover:not(:disabled) { background: #2e7d32; }
  .at__modal-btn-save:disabled { opacity: 0.65; cursor: not-allowed; }
  .at__modal-spinner { width: 13px; height: 13px; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; border-radius: 50%; animation: atSpin 0.7s linear infinite; }
  @keyframes atSpin { to { transform: rotate(360deg); } }
  .at__confirm-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1100; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .at__confirm-box { background: #fff; border-radius: 12px; padding: 28px 24px; max-width: 360px; width: 100%; text-align: center; box-shadow: 0 8px 40px rgba(0,0,0,0.2); }
  .at__confirm-title { font-size: 16px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px; }
  .at__confirm-msg { font-size: 13.5px; color: #666; margin-bottom: 24px; line-height: 1.6; }
  .at__confirm-btns { display: flex; gap: 10px; justify-content: center; }
  .at__confirm-btn-cancel { background: #fff; border: 1px solid #e0e0e0; border-radius: 7px; padding: 9px 20px; font-size: 13px; color: #555; cursor: pointer; font-family: inherit; }
  .at__confirm-btn-delete { background: #c62828; color: #fff; border: none; border-radius: 7px; padding: 9px 20px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: inherit; }
  .at__confirm-btn-delete:hover { background: #b71c1c; }
  @media (max-width: 768px) {
    .at__toolbar { padding: 12px 16px; }
    .at__search { min-width: 160px; }
    .at__toolbar-right { width: 100%; justify-content: space-between; }
    .at__table tbody td, .at__table thead th { padding: 11px 12px; font-size: 12.5px; }
    .at__pagination { padding: 12px 16px; flex-direction: column; align-items: flex-start; }
    .at__modal { max-width: 100%; }
    .at__modal-two-col { grid-template-columns: 1fr; }
  }
`;

const COLUMNS = [
  { key: "fullName", label: "Full Name"  },
  { key: "email",    label: "Email"      },
  { key: "role",     label: "Role"       },
  { key: "position", label: "Position"   },
  { key: "status",   label: "Status"     },
  { key: "actions",  label: "Actions"    },
];

const PAGE_SIZE  = 5;
const EMPTY_FORM = { fullName: "", email: "", password: "", role: "admin", position: "" };
const ROLE_OPTIONS = [
  { value: "admin",      label: "Admin"       },
  { value: "superadmin", label: "Super Admin" },
  { value: "editor",     label: "Editor"      },
];

/* ── Field helper — defined OUTSIDE component so it never remounts ── */
function Field({ label, children }) {
  return (
    <div className="at__modal-field">
      <label className="at__modal-label">{label}</label>
      {children}
    </div>
  );
}

export function AdminTable() {
  const [admins,     setAdmins]     = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [search,     setSearch]     = useState("");
  const [sortKey,    setSortKey]    = useState(null);
  const [sortDir,    setSortDir]    = useState("asc");
  const [page,       setPage]       = useState(1);
  const [toast,      setToast]      = useState(null);

  // Add modal
  const [addOpen,    setAddOpen]    = useState(false);
  const [addForm,    setAddForm]    = useState(EMPTY_FORM);
  const [addLoading, setAddLoading] = useState(false);
  const [addError,   setAddError]   = useState("");
  const [showPw,     setShowPw]     = useState(false);

  // Edit modal
  const [editOpen,    setEditOpen]    = useState(false);
  const [editTarget,  setEditTarget]  = useState(null);
  const [editForm,    setEditForm]    = useState(EMPTY_FORM);
  const [editLoading, setEditLoading] = useState(false);
  const [editError,   setEditError]   = useState("");
  const [showEditPw,  setShowEditPw]  = useState(false);

  // Delete confirm
  const [deleteTarget,  setDeleteTarget]  = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  /* ── GET /api/admin/users ── */
  const fetchAdmins = async () => {
    setLoading(true);
    setFetchError(null);
    try {
      const { data } = await axios.get(`${BASE_URL}/api/admin/users`, authHeaders());
      const payload = data?.data ?? data;
      setAdmins(Array.isArray(payload) ? payload : []);
    } catch (err) {
      setFetchError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAdmins(); }, []);

  /* ── POST /api/admin/users ── */
  const handleAddSubmit = async () => {
    setAddError("");
    const { fullName, email, password, role } = addForm;
    if (!fullName) return setAddError("Full name is required.");
    if (!email)    return setAddError("Email is required.");
    if (!password) return setAddError("Password is required.");
    if (!role)     return setAddError("Role is required.");

    setAddLoading(true);
    try {
      const { data } = await axios.post(`${BASE_URL}/api/admin/users`, addForm, authHeaders());
      setAdmins(prev => [data.data, ...prev]);
      showToast("Admin created successfully.");
      setAddOpen(false);
      setAddForm(EMPTY_FORM);
    } catch (err) {
      setAddError(err?.response?.data?.message || "Failed to create admin.");
    } finally {
      setAddLoading(false);
    }
  };

  /* ── PUT /api/admin/users/:id ── */
  const openEdit = (admin) => {
    setEditTarget(admin);
    setEditForm({
      fullName: admin.fullName || "",
      email:    admin.email    || "",
      password: "",
      role:     admin.role     || "admin",
      position: admin.position || "",
    });
    setEditError("");
    setShowEditPw(false);
    setEditOpen(true);
  };

  const handleEditSubmit = async () => {
    setEditError("");
    const { fullName, email, role } = editForm;
    if (!fullName) return setEditError("Full name is required.");
    if (!email)    return setEditError("Email is required.");
    if (!role)     return setEditError("Role is required.");

    const payload = { ...editForm };
    if (!payload.password) delete payload.password;

    setEditLoading(true);
    try {
      const id = editTarget._id || editTarget.id;
      const { data } = await axios.put(`${BASE_URL}/api/admin/users/${id}`, payload, authHeaders());
      setAdmins(prev => prev.map(a => (a._id || a.id) === id ? data.data : a));
      showToast("Admin updated successfully.");
      setEditOpen(false);
    } catch (err) {
      setEditError(err?.response?.data?.message || "Failed to update admin.");
    } finally {
      setEditLoading(false);
    }
  };

  /* ── PATCH /api/admin/users/:id/status ── */
  const handleToggleStatus = async (admin) => {
    const newStatus = admin.status === "active" ? "inactive" : "active";
    const id = admin._id || admin.id;
    try {
      await axios.patch(`${BASE_URL}/api/admin/users/${id}/status`, { status: newStatus }, authHeaders());
      setAdmins(prev => prev.map(a => (a._id || a.id) === id ? { ...a, status: newStatus } : a));
      showToast(`Admin ${newStatus === "active" ? "activated" : "blocked"}.`);
    } catch (err) {
      showToast(err?.response?.data?.message || "Failed to update status.", "error");
    }
  };

  /* ── DELETE /api/admin/users/:id ── */
  const handleDelete = async () => {
    if (!deleteTarget) return;
    setDeleteLoading(true);
    const id = deleteTarget._id || deleteTarget.id;
    try {
      await axios.delete(`${BASE_URL}/api/admin/users/${id}`, authHeaders());
      setAdmins(prev => prev.filter(a => (a._id || a.id) !== id));
      showToast("Admin deleted.");
      setDeleteTarget(null);
    } catch (err) {
      showToast(err?.response?.data?.message || "Failed to delete admin.", "error");
      setDeleteTarget(null);
    } finally {
      setDeleteLoading(false);
    }
  };

  /* ── Filter / Sort / Paginate ── */
  const filtered = admins.filter(row =>
    ["fullName", "email", "role", "position"].some(k =>
      String(row[k] || "").toLowerCase().includes(search.toLowerCase())
    )
  );

  const sorted = sortKey
    ? [...filtered].sort((a, b) => {
        const av = String(a[sortKey] || "").toLowerCase();
        const bv = String(b[sortKey] || "").toLowerCase();
        return sortDir === "asc" ? av.localeCompare(bv) : bv.localeCompare(av);
      })
    : filtered;

  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const paginated  = sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handleSort = (key) => {
    if (key === "status" || key === "actions") return;
    if (sortKey === key) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortKey(key); setSortDir("asc"); }
    setPage(1);
  };

  // Field is defined outside — see below the component

  return (
    <>
      <style>{styles}</style>
      <div className="at__wrapper">

        {/* Toolbar */}
        <div className="at__toolbar">
          <div className="at__toolbar-left">
            <div className="at__search">
              <span className="at__search-icon">🔍</span>
              <input type="text" placeholder="Search admins..."
                value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
            </div>
          </div>
          <div className="at__toolbar-right">
            <span className="at__count">{filtered.length} record{filtered.length !== 1 ? "s" : ""}</span>
            <button className="at__add-btn" onClick={() => { setAddForm(EMPTY_FORM); setAddError(""); setShowPw(false); setAddOpen(true); }}>
              + <span>Add Admin</span>
            </button>
          </div>
        </div>

        {fetchError && <div className="at__fetch-error">⚠ {fetchError}</div>}

        {/* Table */}
        <div className="at__table-wrap">
          <table className="at__table">
            <thead>
              <tr>
                {COLUMNS.map(col => (
                  <th key={col.key} onClick={() => handleSort(col.key)}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={COLUMNS.length} className="at__loading">Loading admins…</td></tr>
              ) : paginated.length === 0 ? (
                <tr><td colSpan={COLUMNS.length} className="at__empty">No admins found</td></tr>
              ) : (
                paginated.map(admin => (
                  <tr key={admin._id || admin.id}>
                    <td>{admin.fullName || "—"}</td>
                    <td>{admin.email    || "—"}</td>
                    <td>{admin.role     || "—"}</td>
                    <td>{admin.position || "—"}</td>
                    <td>
                      <span className={`at__status-badge at__status-badge--${admin.status === "active" ? "active" : "inactive"}`}>
                        {admin.status === "active" ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>
                      <div className="at__actions">
                        <button className="at__action-btn at__action-btn--edit" onClick={() => openEdit(admin)}>Edit</button>
                        <button
                          className={`at__action-btn ${admin.status === "active" ? "at__action-btn--disable" : "at__action-btn--enable"}`}
                          onClick={() => handleToggleStatus(admin)}
                        >
                          {admin.status === "active" ? "Block" : "Activate"}
                        </button>
                        <button className="at__action-btn at__action-btn--delete" onClick={() => setDeleteTarget(admin)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="at__pagination">
          <span className="at__pagination-info">
            Showing {sorted.length === 0 ? 0 : Math.min((page - 1) * PAGE_SIZE + 1, sorted.length)}–{Math.min(page * PAGE_SIZE, sorted.length)} of {sorted.length}
          </span>
          <div className="at__pagination-btns">
            <button className="at__page-btn" onClick={() => setPage(1)} disabled={page === 1}>«</button>
            <button className="at__page-btn" onClick={() => setPage(p => p - 1)} disabled={page === 1}>‹</button>
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 1)
              .reduce((acc, p, i, arr) => {
                if (i > 0 && p - arr[i - 1] > 1) acc.push("...");
                acc.push(p);
                return acc;
              }, [])
              .map((p, i) => p === "..."
                ? <span key={`e${i}`} style={{ padding: "0 4px", color: "#aaa" }}>…</span>
                : <button key={p} className={`at__page-btn ${page === p ? "at__page-btn--active" : ""}`} onClick={() => setPage(p)}>{p}</button>
              )}
            <button className="at__page-btn" onClick={() => setPage(p => p + 1)} disabled={page === totalPages}>›</button>
            <button className="at__page-btn" onClick={() => setPage(totalPages)} disabled={page === totalPages}>»</button>
          </div>
        </div>
      </div>

      {/* Add Modal */}
      {addOpen && (
        <div className="at__modal-overlay" onClick={() => setAddOpen(false)}>
          <div className="at__modal" onClick={e => e.stopPropagation()}>
            <div className="at__modal-header">
              <span className="at__modal-title">Add Admin</span>
              <button className="at__modal-close" onClick={() => setAddOpen(false)}>&times;</button>
            </div>
            <div className="at__modal-body">
              {addError && <div className="at__modal-error">⚠ {addError}</div>}
              <Field label="Full Name">
                <input className="at__modal-input" type="text" placeholder="e.g. John Doe"
                  value={addForm.fullName} onChange={e => setAddForm(p => ({ ...p, fullName: e.target.value }))} />
              </Field>
              <div className="at__modal-two-col">
                <Field label="Email">
                  <input className="at__modal-input" type="email" placeholder="you@company.com"
                    value={addForm.email} onChange={e => setAddForm(p => ({ ...p, email: e.target.value }))} />
                </Field>
                <Field label="Position">
                  <input className="at__modal-input" type="text" placeholder="e.g. Project Manager"
                    value={addForm.position} onChange={e => setAddForm(p => ({ ...p, position: e.target.value }))} />
                </Field>
              </div>
              <Field label="Role">
                <select className="at__modal-select" value={addForm.role}
                  onChange={e => setAddForm(p => ({ ...p, role: e.target.value }))}>
                  <option value="">Select role</option>
                  {ROLE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </Field>
              <Field label="Password">
                <div className="at__modal-pw-wrap">
                  <input className="at__modal-input" type={showPw ? "text" : "password"}
                    placeholder="Enter password"
                    value={addForm.password} onChange={e => setAddForm(p => ({ ...p, password: e.target.value }))} />
                  <button type="button" className="at__modal-eye" onClick={() => setShowPw(v => !v)}>
                    {showPw ? "🙈" : "👁"}
                  </button>
                </div>
              </Field>
            </div>
            <div className="at__modal-footer">
              <button className="at__modal-btn-cancel" onClick={() => setAddOpen(false)}>Cancel</button>
              <button className="at__modal-btn-save" onClick={handleAddSubmit} disabled={addLoading}>
                {addLoading ? <><span className="at__modal-spinner" /> Saving…</> : "Create Admin"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editOpen && (
        <div className="at__modal-overlay" onClick={() => setEditOpen(false)}>
          <div className="at__modal" onClick={e => e.stopPropagation()}>
            <div className="at__modal-header">
              <span className="at__modal-title">Edit Admin</span>
              <button className="at__modal-close" onClick={() => setEditOpen(false)}>&times;</button>
            </div>
            <div className="at__modal-body">
              {editError && <div className="at__modal-error">⚠ {editError}</div>}
              <Field label="Full Name">
                <input className="at__modal-input" type="text" placeholder="e.g. John Doe"
                  value={editForm.fullName} onChange={e => setEditForm(p => ({ ...p, fullName: e.target.value }))} />
              </Field>
              <div className="at__modal-two-col">
                <Field label="Email">
                  <input className="at__modal-input" type="email" placeholder="you@company.com"
                    value={editForm.email} onChange={e => setEditForm(p => ({ ...p, email: e.target.value }))} />
                </Field>
                <Field label="Position">
                  <input className="at__modal-input" type="text" placeholder="e.g. Project Manager"
                    value={editForm.position} onChange={e => setEditForm(p => ({ ...p, position: e.target.value }))} />
                </Field>
              </div>
              <Field label="Role">
                <select className="at__modal-select" value={editForm.role}
                  onChange={e => setEditForm(p => ({ ...p, role: e.target.value }))}>
                  <option value="">Select role</option>
                  {ROLE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </Field>
              <Field label="New Password">
                <div className="at__modal-pw-wrap">
                  <input className="at__modal-input" type={showEditPw ? "text" : "password"}
                    placeholder="Leave blank to keep current"
                    value={editForm.password} onChange={e => setEditForm(p => ({ ...p, password: e.target.value }))} />
                  <button type="button" className="at__modal-eye" onClick={() => setShowEditPw(v => !v)}>
                    {showEditPw ? "🙈" : "👁"}
                  </button>
                </div>
              </Field>
            </div>
            <div className="at__modal-footer">
              <button className="at__modal-btn-cancel" onClick={() => setEditOpen(false)}>Cancel</button>
              <button className="at__modal-btn-save" onClick={handleEditSubmit} disabled={editLoading}>
                {editLoading ? <><span className="at__modal-spinner" /> Saving…</> : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirm */}
      {deleteTarget && (
        <div className="at__confirm-overlay" onClick={() => setDeleteTarget(null)}>
          <div className="at__confirm-box" onClick={e => e.stopPropagation()}>
            <p className="at__confirm-title">Delete Admin</p>
            <p className="at__confirm-msg">
              Are you sure you want to delete <strong>{deleteTarget.fullName || deleteTarget.email}</strong>? This action cannot be undone.
            </p>
            <div className="at__confirm-btns">
              <button className="at__confirm-btn-cancel" onClick={() => setDeleteTarget(null)}>Cancel</button>
              <button className="at__confirm-btn-delete" onClick={handleDelete} disabled={deleteLoading}>
                {deleteLoading ? "Deleting…" : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast && (
        <div className={`at__toast ${toast.type === "error" ? "at__toast--error" : ""}`}>
          {toast.msg}
        </div>
      )}
    </>
  );
}

export default AdminTable;